import { API } from './instances'
import { mockSurvey } from '../constants/mockSurvey'

const getSurvey = async (initialUrl, module) => {
  const url = `/Encuestas?initialUrl=${initialUrl}&module=${module}`
  return await API.get(url, { skipErrorMessage: true })
}

const sendSurvey = async (module, params, surveyType) => {
  const url = `/Encuestas/${module}/Respuestas?surveyType=${surveyType}`
  return await API.post(url, params,{ skipErrorMessage: true })
}

const updateSurvey = async (module, idSurvey, params, surveyType) => {
  const url = `/Encuestas/${module}/Respuestas?surveyId=${idSurvey}&surveyType=${surveyType}`
  return await API.post(url, params, { skipErrorMessage: true })
}

const getSurveyPopupStatus = async (initialUrl, module) => {
  const url = `/Encuestas/PopupTurnos?initialUrl=${initialUrl}&module=${module}`
  return await API.get(url, { skipErrorMessage: true })
}

export default {
  getSurvey,
  sendSurvey,
  updateSurvey,
  getSurveyPopupStatus,
}
